<div class="form-group">
  @if ((question.question_copy || question.email_version) && showLabel) {
    <label [innerHTML]="question.question_copy || question.email_version"></label>
  }
  <div class="custom-step">
    <div
      class="custom-step__control custom-step__control--dsc"
      (click)="setStep(false)"
      [ngClass]="{'custom-step__control--disabled': value === minValue}">
      <svg class="icon"><use xlink:href="#minus"></use></svg>
    </div>
    <input
      class="form-control"
      type="number"
      [min]="minValue"
      [max]="maxValue"
      [name]="uniqueControlName"
      [(ngModel)]="value"
      (ngModelChange)="onChange()"/>
      <div
        class="custom-step__control custom-step__control--asc"
        (click)="setStep(true)"
        [ngClass]="{'custom-step__control--disabled': value === maxValue}">
        <svg class="icon"><use xlink:href="#plus"></use></svg>
      </div>
    </div>
  </div>
